<!-- Search form -->

<div class="mt-5">
<form class="form-inline float-right ">
    <div class="d-flex pr-4 text-white" >
      <a class="btn btn-primary btn-sm" (click)="backClicked()" routerLinkActive="blue"  translate ><i class="fa fa-times"></i> BACK</a>
    </div>

    <div class="d-flex text-white ">
      <a class="btn btn-primary border-white btn-sm text-white " style="font-family: DINPro;" 
      (click)='editUser(userQueryDetails[0])' routerLinkActive="blue" translate><i class="fa fa-user pr-2"></i>EDIT</a>
    </div>
    
  </form>
  
  <!-- Content Header (Page header) -->
  <section class="content-header ml-2">
      <div class="d-flex justify-content-between pt-1 align-items-center">
          <h3 translate>User</h3>
  
          <div>
        <!--<?php //if(in_array("addAsset",$perms)) { ?>-->
          <!--<a class="btn btn-dark btn-sm " *ngIf="perms===true"
                  routerLink="/register" routerLinkActive="blue"><i class="fa fa-edit pr-2"></i>EDIT</a>-->
              <!--<?php //} ?>-->
          </div>
      </div>
  </section>
</div>
  <!--
  <div class="container p-2">
      <ul class="nav nav-tabs d-flex justify-content-around">
      <li class="nav-item ">
        <a class="nav-link "     routerLink="/users" routerLinkActive="active" >Home</a>
      </li>
  
      <li class="nav-item">
        <a class="nav-link " (click)="onSelect('/employee-details','Profile')" routerLinkActive="active">Profile</a>
      </li>
  
      <li class="nav-item">
        <a class="nav-link " routerLink="/user-logs" routerLinkActive="active">Access</a>
      </li>
  
        <li class="nav-item " >
          <a class="nav-link " (click)="onSelect('/user-logs',userQueryDetails[0].userName)"  >Logs</a>
        </li>
  
  
        <li class="nav-item">
          <a class="nav-link " routerLinkActive="active">Documents</a>
        </li>
  
  </ul>
  </div>-->
  
  
  
  <!--<app-user-nav-bar [UsernameFromParent]="UsernameFromParent" [UserFirstNameFromParent]="userQueryDetails?.firstName" [UserLastNameFromParent]="userQueryDetails?.lastName" ></app-user-nav-bar>-->
  
  <div class="bg-white shadow rounded overflow-hidden pb-5">
      <form [formGroup]="userInfoForm" *ngFor="let details of userQueryDetails">
      <div class="col-sm-12 px-4 pt-4 pb-4  d-flex flex-column " style="background-color: #132a42;" >
        <div class=" row media align-items-end profile-header">
  
          <div class="col-md-8 media-body mb-5 text-white" style="font-family:Trebuchet MS; " >
              <h3 >{{details.firstName}} {{details.middleName}} {{details.lastName}}</h3>
              
            <p class="medium mt-3" translate ><i class="fa fa-user mr-2"></i>User Name: {{details?.userName}}</p>
            <p class="medium mt-2" translate> <i class="fa fa-clipboard-list mr-2"></i>Branch: {{details?.branch}}</p>
            <p class="medium mt-2" translate > <i class="fa fa-calendar-day mr-2"></i>Date Created: {{details?.dateCreated}}</p>
            <p class="medium mt-2" translate *ngIf="details?.expertise!=null && details?.expertise!=[] && details.role=='Sales Representative'"> <i class="fa fa-calendar-day mr-2"  ></i>Expertise: {{details?.expertise}}</p>
        
          </div>
        
        
  
        <div class="col-md-4 pb-5 d-flex flex-column ">
       
  
      
        <div class="d-flex flex-column float-right " *ngIf='details?.status==="Pending Approval"'>
          <span class="fa fa-pause p-2" style="font-size: 80px; text-align: center; color: #fff9ae;" ></span>
          <label  style="font-weight: bolder; font-size: 20px; text-align: center; color: #fff9ae; font-family:Trebuchet MS;" translate>PENDING APPROVAL</label>
        </div>
  
  
        <div class="d-flex flex-column float-right  " *ngIf='details?.status==="Active"'>
          <span class="fa fa-check p-2" style="font-size: 80px; text-align: center; color:#FFFFFF;" ></span>
          <label  style="font-weight: bolder; font-size: 15px; text-align: center; color: #FFFFFF; font-family:Trebuchet MS;" translate>ACTIVE</label>
        </div>
  
        <div class="d-flex flex-column float-right" *ngIf='details?.status==="Processing"'>
          <span class="fa fa-spinner p-2" style="font-size: 80px; text-align: center; color: #3F6578;" ></span>
          <label  style="font-weight: bolder; font-size: 20px; text-align: center; color: #3F6578; font-family:Trebuchet MS;" translate>PROCESSING</label>
        </div>
  
        <div class="d-flex flex-column float-right" *ngIf='details?.status==="Partial Completed"'>
          <span class="fa fa-star-half-alt p-2" style="font-size: 80px; text-align: center; color: lightgray;" ></span>
          <label  style="font-weight: bolder; font-size: 20px; text-align: center; color: lightgray; font-family:Trebuchet MS;" translate>PARTIAL COMPLETED</label>
        </div>
  
        <div class="d-flex flex-column float-right" *ngIf='details?.status==="InActive"'>
         
          <span class="fa fa-times-circle p-2" style="font-size: 80px; text-align: center; color: lightcoral;" ></span>
          <label  style="font-weight: bolder; font-size: 20px; text-align: center; color: lightcoral; font-family:Trebuchet MS;" translate>InActive</label>
        </div>
  
      </div>
  
        <div class="2-100 col-md-12 mb-2 d-flex justify-content-around ">
          <button type="button" class="btn bg-white m-2 w-25  " style="color: #275787; " *ngIf=" details?.status=='Active'" (click)=openPasswordResetModal(userQueryDetails[0],passwordResetModal) translate>Password Reset</button>
          <button type="button" class="btn bg-white m-2 w-25" style="color: lightcoral;" *ngIf='details?.status=="Active" ' (click)=openStatusChangetModal(userQueryDetails[0],statusModal) translate>Deactivate Account</button>
          <button type="button" class="btn bg-white m-2 w-25" style="color: #209769;" *ngIf='(details?.status=="InActive" || details?.status=="") && isSystemAdmin()'(click)=openStatusChangetModal(userQueryDetails[0],statusModal) translate>Activate Account</button>
          <button type="button" class="btn bg-white m-2 w-25" style="color: #5f441e;" *ngIf="details?.status=='Active'"  (click)=openBranchModal(userQueryDetails[0],branchModal) translate>Branch Management</button>
          <button type="button" class="btn bg-white m-2 w-25" style="color: #209769;" *ngIf=" details?.status=='Active'"  (click)=openRoleModal(userQueryDetails[0],roleModal) translate>Role Management</button>
          <button type="button" class="btn bg-white m-2 w-25" style="color: #202563;" *ngIf=" details?.status=='Active' && (details?.role=='Sales Representative'  || details?.role=='Sales Support'  || details?.role=='Management'  || details?.role=='Manager'  || details?.role=='Power User'  || details?.role=='Administrator')"  (click)=openExpertiseModal(userQueryDetails[0],expertiseModal) translate>Expertise Assignment</button>
          <!--<button type="button" class="btn bg-white m-2 w-25" style="color: #365294;" *ngIf="(isSystemAdmin()) && details?.status=='Active'"  (click)=openAccessModal(userQueryDetails[0],accessManagementModal)>Access Management</button>-->
      </div>
  
        
      </div>
      </div>
     <!-- {{ employeeuserForm.value | json}}
    
      {{employees | json}}-->
    
      <div class="container py-5 " *ngIf="employeeviewmodel!=null">
       
          <div class="box-title border-bottom border-dark  "><strong translate>Employment Details</strong></div>
          <div class="col-xs-12  p-2">
            <div class="row pt-2 border border-dark">
  
  
              
                  <div class="d-flex flex-column col-md-12 py-2">
                    <label class="   " ><strong translate>Title</strong> </label>
                  
                  <h4 class=" border-bottom border-5" style="font-family:Trebuchet MS;  font-weight: bold;" >{{employeeviewmodel?.title}}</h4>
              </div>
  
                
  <hr>
              <div class="col-md-6 ">
                <div class="d-flex flex-column " >
    
    
    
    
                   
                      <div class="d-flex flex-column py-3">
                      <label class=""><strong translate> Manager </strong></label>
                    <h6 class=" " style="font-family:Trebuchet MS; " >{{employeeviewmodel?.manager}}</h6>
                  </div>
    
    
                  <div class="d-flex flex-column py-3">
                      <label class=""><strong translate>Work Email</strong></label>
                    <h6 class="" style="font-family:Trebuchet MS; ">{{employeeviewmodel?.workEmail}}</h6>
                  
                  </div>
    
    
                  <div class="row ">
                      <div class="col-sm-5 pl-3">
                        <div class="d-flex flex-column ">
                         
                            <label class="  "><strong translate>Work Phone</strong></label>
                            <h6 class="" style="font-family:Trebuchet MS; ">{{employeeviewmodel?.workPhone}}</h6>
                        </div>
                      </div>
    
                      <div class="col-md-6">
                        <div class="d-flex flex-column ">
                   
                            <label class=" "><strong translate>Ext</strong></label>
                            <h6 class="" style="font-family:Trebuchet MS; ">{{employeeviewmodel?.ext}}</h6>
                        </div>
                      </div>
                    </div>
  
  
                </div>
              </div>
                  
     <div class="col-md-6  ">
              
                    <div class="d-flex flex-column py-3">
                     
                        <label class=" mb-2 "><strong translate>Department</strong></label>
                      <h6 class="" style="font-family:Trebuchet MS; ">{{employeeviewmodel?.department}}</h6>
                    </div>
    
                    <div class="row ">
                      <div class="col-sm-5 pl-3">
                        <div class="d-flex flex-column ">
                         
                            <label class="  "><strong translate>Location</strong></label>
                            <h6 class="" style="font-family:Trebuchet MS; ">{{employeeviewmodel?.location}}</h6>
                        </div>
                      </div>
    
                      <div class="col-md-6">
                        <div class="d-flex flex-column ">
                   
                            <label class=" "><strong translate>Province</strong></label>
                            <h6 class="" style="font-family:Trebuchet MS; ">{{details?.province}}</h6>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column py-3">
                        <label class=""><strong translate>Postal / Zip Code</strong></label>
                        <h6 class="" style="font-family:Trebuchet MS; ">{{details?.postalCode}}</h6>
                    </div>
                 
                </div>
              </div>
  
  
  
              </div>
        
  
  
  
        </div>
    
  
      </form>
        </div>
  
  
  
  
  <!-----------Password Reset Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
  <ng-template #passwordResetModal let-modal>
      <div class="modal-header">
       <h5 class="modal-title" id="statuLabel" translate>Password Reset</h5>
       <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
       </button>
      </div>
      
      <div class="modal-body">
       <form [formGroup]="passwordResetForm" >
        <div class="form-group row">
          <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
         <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>User Name</label>
         <div class="col-sm-8">
          <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
         </div>
        </div>
        <div class="form-group row">
         <label for="name" class="col-sm-4 col-form-label font-weight-bold" translate> Name</label>
         <div class="col-sm-8">
          <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
         </div>
        </div>
        <div class="form-group row">
         <label for="status" class="col-sm-4 col-form-label font-weight-bold" translate> Status</label>
         <div class="col-sm-8">
          <input type="text" disabled class="form-control bg-white border-0" formControlName="currentStatus" id="currentStatus">
         </div>
        </div>
  
        <div class="form-group row">
          <label for="password" class="col-sm-4 col-form-label font-weight-bold" translate> New Password</label>
          <div class="col-sm-8">
           <input type="text" type="password" class="form-control bg-white " [class.is-invalid]="formErrors.password" (blur)="logValidationErrors(passwordResetForm)" formControlName="password">
           <div class=" pb-2  text-danger"
           [class.d-none]="!formErrors.password">
           <small>{{formErrors.password}}</small></div>
  
           
          </div>
         </div>
  
  
         <div class="form-group row">
          <label for="confirmPassword" class="col-sm-4 col-form-label font-weight-bold" translate> Confirm Password</label>
          <div class="col-sm-8">
           <input type="text" type="password" class="form-control bg-white " [class.is-invalid]="formErrors.confirmPassword" (blur)="logValidationErrors(passwordResetForm)" formControlName="confirmPassword" id="confirmPassword">
          
          <div class=" pb-2 text-danger"
          [class.d-none]="!formErrors.confirmPassword">
          <small>{{formErrors.confirmPassword}}</small></div>
      </div>
          
         </div>
  
  
       
        <div class="modal-footer">
         <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
         <button type="submit" class="btn btn-primary" (click)=submitPasswordReset(); translate>Confirm</button>
        </div>
       </form>
      </div>
     </ng-template>
  
  
  
     <!-----------Status Change Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
  <ng-template #statusModal let-modal>
      <div class="modal-header">
       <h5 class="modal-title" id="statuLabel" translate>Status Change</h5>
       <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
       </button>
      </div>
      
      <div class="modal-body">
       <form [formGroup]="statusChangeForm" >
        <div class="form-group row">
          <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
          <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>User Name</label>
          <div class="col-sm-8">
           <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
          </div>
         </div>
         <div class="form-group row">
          <label for="name" class="col-sm-4 col-form-label font-weight-bold" translate> Name</label>
          <div class="col-sm-8">
           <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
          </div>
         </div>
        <div class="form-group row">
         <label for="username" class="col-sm-4 col-form-label font-weight-bold" translate>Current Status</label>
         <div class="col-sm-8">
          <input type="text" disabled class="form-control bg-white border-0" formControlName="currentStatus" id="currentStatus">
         </div>
        </div>
        <div class="form-group row">
          <label for="newStatus" class="col-sm-4 col-form-label font-weight-bold" translate> Change Status to </label>
          <div class="col-sm-8">
           <input type="text" disabled class="form-control bg-white border-0 " formControlName="newStatus" id="newStatus">
          </div>
        </div>
       
        <div class="modal-footer">
         <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
         <button type="submit" class="btn btn-primary" (click)=saveIndividualStatus(); translate>Confirm</button>
        </div>
       </form>
      </div>
     </ng-template>
  
  
  
  
      <!----------Branch Change Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
  <ng-template #branchModal let-modal>
    <div class="modal-header">
     <h5 class="modal-title" id="statuLabel" translate>Branch Change</h5>
     <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="branchChangeForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>User Name</label>
        <div class="col-sm-8">
         <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
        </div>
       </div>
       <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label font-weight-bold" translate> Name</label>
        <div class="col-sm-8">
         <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
        </div>
       </div>
      <div class="form-group row">
       <label  class="col-sm-4 col-form-label font-weight-bold" translate>Current Branch</label>
       <div class="col-sm-8">
        <input type="text" disabled class="form-control bg-white border-0" formControlName="currentBranch" id="currentBranch">
       </div>
      </div>
      <div class="form-group row">
        <label  class="col-sm-4 col-form-label font-weight-bold" translate>Current Categories</label>
        <div class="col-sm-8">
         <select class="form-control  select2 select2-hidden-accessible " formControlName="newBranch" id="newBranch">
          <option value=""  disabled selected translate>Select Branch</option>
          <option data-tagprefix=''*ngFor='let branchs of branchCategories' value={{branchs.name}}>{{branchs.name}}</option>
         </select>
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveIndividualBranch(); translate>Confirm</button>
      </div>
     </form>
    </div>
   </ng-template>
  
  

      <!----------Expertise Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
      <ng-template #expertiseModal let-modal>
        <div class="modal-header">
         <h5 class="modal-title" id="statuLabel" translate>Expertise</h5>
         <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
         </button>
        </div>
        
        <!--{{expertiseForm.value | json}}-->
        <div class="modal-body">
         <form [formGroup]="expertiseForm" >
          <div class="form-group row">
            <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
            <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>User Name</label>
            <div class="col-sm-8">
             <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
            </div>
           </div>
           <div class="form-group row">
            <label for="name" class="col-sm-4 col-form-label font-weight-bold" translate> Name</label>
            <div class="col-sm-8">
             <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
            </div>
           </div>
    
          <div class="form-group row">
            <label  class="col-sm-4 col-form-label font-weight-bold" translate> Expertise </label>
            <div class="col-sm-8">
              <label class="m-2" *ngFor="let ex of expertise">
                <input type="checkbox" [value]="ex" [checked]="expertiseForm.value.currentExpertise.includes(ex.name)" (change)="onExpertiseChange(ex.name, $event)"/> {{ex.name}}
              </label>
            </div>
          </div>
         
          <div class="modal-footer">
           <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
           <button type="submit" class="btn btn-primary" (click)=saveIndividualExpertise(); translate>Confirm</button>
          </div>
         </form>
        </div>
       </ng-template>
      
   
  
      <!----------Role Change Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
  <ng-template #roleModal let-modal>
    <div class="modal-header">
     <h5 class="modal-title" id="statuLabel" translate>Role Change</h5>
     <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="roleChangeForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>User Name</label>
        <div class="col-sm-8">
         <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
        </div>
       </div>
       <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label font-weight-bold" translate> Name</label>
        <div class="col-sm-8">
         <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
        </div>
       </div>
      <div class="form-group row">
       <label  class="col-sm-4 col-form-label font-weight-bold" translate>Current Role</label>
       <div class="col-sm-8">
        <input type="text" disabled class="form-control bg-white border-0" formControlName="currentRole" id="currentRole">
       </div>
      </div>
      <div class="form-group row">
        <label for="newRole" class="col-sm-4 col-form-label font-weight-bold" translate> Change Role to </label>
        <div class="col-sm-8">
         <select class="form-control  select2 select2-hidden-accessible " formControlName="newRole" id="newRole">
          <option value=""  disabled selected>Select Role</option>
          <option data-tagprefix=''*ngFor='let roles of roleCategories' value={{roles.name}}>{{roles.name}}</option>
         </select>
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveIndividualRole(); translate>Confirm</button>
      </div>
     </form>
    </div>
   </ng-template>
  
  
  
       <!----------Access Management Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
  <ng-template #accessManagementModal let-modal>
    <div class="modal-header">
     <h5 class="modal-title" id="statuLabel" translate>Access Management</h5>
     <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="accessManagementForm" >
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg" id="modalMsg">
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>User Name</label>
        <div class="col-sm-8">
         <input type="text" disabled class="form-control bg-white border-0" formControlName="userName" id="userName">
        </div>
       </div>
       <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label font-weight-bold" translate> Name</label>
        <div class="col-sm-8">
         <input type="text" disabled class="form-control bg-white border-0" formControlName="fullName" id="fullName">
        </div>
       </div>
      <div class="form-group row">
       <label  class="col-sm-5 col-form-label font-weight-bold" translate> HR</label>
       <div class="row col-sm-6 ">
        <input type="checkbox"  class="form-check-input " formControlName="HRCheck"  (change)="changeFormControlValue($event,$event.target.checked,'HRCheck')">
        <select class="form-control select2 select2-hidden-accessible ml-3"  *ngIf="accessManagementForm.controls.HRCheck.value==true"  formControlName="HRAccess" >
          <option value="Select Role"  disabled selected>Select Role</option>
          <option value="Read">Read</option>
          <option value="Full Control">Full Control</option>
         </select>
       </div>
      </div>
  
       <div class="form-group row ">
        <label  class="col-sm-5 col-form-label font-weight-bold" translate> Inventory</label>
       <div class="row col-sm-6  float-right ">
        <input type="checkbox"  class="form-check-input  " formControlName="inventoryCheck"  (change)="changeFormControlValue($event,$event.target.checked,'inventoryCheck')">
       
        <select class="form-control select2 select2-hidden-accessible ml-3"  *ngIf="accessManagementForm.controls.inventoryCheck.value==true" formControlName="inventoryAccess" id="inventoryAccess">
          <option value=""  disabled selected translate>Select Role</option>
          <option value="Read">Read</option>
          <option value="Full Control">Full Control</option>
         </select>
       </div>
       </div>
       <div class="form-group row">
        <label  class="col-sm-5 col-form-label font-weight-bold" translate> Helpdesk</label>
       <div class="row col-sm-6" >
        <input type="checkbox"  class="form-check-input " formControlName="helpdeskCheck" id="helpdeskCheck"  (change)="changeFormControlValue($event,$event.target.checked,'helpdeskCheck')">
  
        <select class="form-control select2 select2-hidden-accessible ml-3"  *ngIf="accessManagementForm.controls.helpdeskCheck.value ==true" formControlName="helpdeskAccess" id="helpdeskAccess">
          <option value=""  disabled selected>Select Role</option>
          <option value="Read">Read</option>
          <option value="Full Control">Full Control</option>
         </select>
       </div>
       </div>
  
       <div class="form-group row">
        <label  class="col-sm-5 col-form-label font-weight-bold" translate>Reports</label>
       <div class="row col-sm-6">
        <input type="checkbox"  class="form-check-input " formControlName="reportCheck" (change)="changeFormControlValue($event,$event.target.checked,'reportCheck')">
        <select class="form-control select2 select2-hidden-accessible ml-3"   *ngIf="accessManagementForm.controls.reportCheck.value==true" formControlName="reportAccess"  (blur)="validateIfChecked()">
          <option value=""  disabled selected>Select Role</option>
          <option value="Read">Read</option>
          <option value="Full Control">Full Control</option>
         </select> 
  
      
      </div>
  
      </div>
    
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" [disabled]='!accessManagementForm.valid' (click)=saveIndividualSiteAccess(); translate>Confirm</button>
      </div>
     </form>
    </div>
   </ng-template>
  
  
  <!-----------------------Success Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
     
  <button id="openIndividualSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#IndividualSuccessModal">Open Modal</button>
  <!-- Modal -->
  <div id="IndividualSuccessModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
  
          <!-- Modal content-->
          <div class="modal-content">
              <div class="modal-header">
  
                  <h4 class="modal-title text-success" translate>SUCCESS</h4>
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="modal-body text-success">
                  <p>User account have been modified</p>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-default" 
                      data-dismiss="modal" (click)="refresh()" translate>Close</button>
              </div>
          </div>
  
      </div>
  </div>
  
  <!---------------------Error Modal----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
  <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
  <!-- Modal -->
  <div id="ErrorModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
  
          <!-- Modal content-->
          <div class="modal-content">
              <div class="modal-header">
  
                  <h4 class="modal-title text-danger" translate>ERROR</h4>
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="modal-body text-danger">
                  <p>{{error}}</p>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-default" (click)="backClicked()"
                      data-dismiss="modal" translate>Close</button>
              </div>
          </div>
  
      </div>
  </div>